import { render } from "./ProjectPanelView.vue?vue&type=template&id=b939fd72"
import script from "./ProjectPanelView.vue?vue&type=script&lang=js"
export * from "./ProjectPanelView.vue?vue&type=script&lang=js"

import "./ProjectPanelView.vue?vue&type=style&index=0&id=b939fd72&lang=css"

import exportComponent from "E:\\project\\spiderx-gui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__